<template>
  <div
    class="deck-row"
    :style="{
      'grid-template-columns': deckColumns,
    }"
  >
    <div
      v-for="(col, index) in Object.values(columns)"
      :key="`col:${numberedRow}:${index}`"
      class="deck-col"
    >
      <seat-map-block
        :obj="{
          ...getObject(col, index),
        }"
      />
    </div>
  </div>
</template>

<script>
  import { build_deck_columns } from './logic';
  import Block from '@liveflight/components/blocks/seat-map/seat-map-block.vue';

  const EMPTY_SEAT = {
    type: 'empty',
  };

  export default {
    name: 'deck-row',
    components: {
      'seat-map-block': Block,
    },
    props: {
      isExitRow: {
        type: Boolean,
        default: false,
      },
      currentTravelerChoosing: {
        type: String,
        default: () => '',
      },
      showSuitableForInfant: {
        type: Boolean,
        default: false,
      },
      deckWidth: Number,
      rowObjects: Object,
      columns: Object,
      numberedRow: Number,
      selectedSeats: Object,
      handleSeatSelection: Function,
    },
    computed: {
      deckColumns() {
        return build_deck_columns(this.deckWidth);
      },
    },
    methods: {
      getObject(col, index) {
        const type = this.isExitRow ? 'exits' : 'blocks';
        const elementsByType = this.rowObjects[type];
        if (!elementsByType) {
          return EMPTY_SEAT;
        }

        const elem = elementsByType[index];
        if (!elem) {
          return EMPTY_SEAT;
        }
        const obj = {
          ...elem,
          isExitRow: this.isExitRow,
          currentTravelerChoosing: this.currentTravelerChoosing,
          type: elem.type || 'empty',
        };
        if (obj.type === 'seat') {
          obj.passenger = this.selectedSeats[obj.number];
          obj.handleSeatSelection = this.handleSeatSelection;
          obj.showSuitableForInfant = this.showSuitableForInfant;
        }
        if (this.numberedRow && col.isHallway && !this.isExitRow) {
          obj.row = this.numberedRow;
        }
        return obj;
      },
    },
  };
</script>

<style lang="scss">
  .deck-row {
    display: grid;
    gap: 5px;
    align-items: start;
  }
  .deck-col {
    line-height: 0;
    margin: 0;
    padding: 0;
  }
</style>
